function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import "./CollapseBase.css";

var CollapseBase = /*#__PURE__*/function (_Component) {
  _inheritsLoose(CollapseBase, _Component);

  function CollapseBase(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleTransitionEnd = function () {
      // After the container has transitioned to expanded, set height of
      // container to auto to allow reflow on browser resize.
      if (_this.state.isExpanded) {
        _this.setState({
          autoHeight: true,
          displayNone: false
        });
      } else if (_this.props.lines === 0) {
        _this.setState({
          displayNone: true
        });
      }
    };

    _this.state = {
      autoHeight: _this.props.expanded,
      displayNone: !_this.props.expanded && _this.props.lines === 0,
      isExpanded: _this.props.expanded
    };
    return _this;
  }

  var _proto = CollapseBase.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    var expanded = this.props.expanded;

    if (expanded !== prevProps.expanded) {
      if (!expanded) {
        // Collapsing. Set container back to fixed height to allow
        // transition animation to work.
        this.setState({
          // eslint-disable-line
          autoHeight: false
        });
      } // Slight delay so the fixed height is rendered and then the
      // container can be collapsed/expand. 25ms seems to be the least we
      // can do for Firefox.


      window.setTimeout(function () {
        _this2.setState({
          isExpanded: expanded
        });
      }, 25);
    }
  };

  _proto.getCompactHeight = function getCompactHeight() {
    return this.props.lineHeight * this.props.lines;
  };

  _proto.getMaxHeight = function getMaxHeight() {
    return this.container.scrollHeight + this.props.paddingBottom;
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props = this.props,
        id = _this$props.id,
        lines = _this$props.lines,
        children = _this$props.children,
        className = _this$props.className,
        expanded = _this$props.expanded,
        paddingBottom = _this$props.paddingBottom,
        lineHeight = _this$props.lineHeight,
        onExpandedChange = _this$props.onExpandedChange,
        rest = _objectWithoutProperties(_this$props, ["id", "lines", "children", "className", "expanded", "paddingBottom", "lineHeight", "onExpandedChange"]); // eslint-disable-line no-unused-vars


    var _this$state = this.state,
        autoHeight = _this$state.autoHeight,
        displayNone = _this$state.displayNone,
        isExpanded = _this$state.isExpanded;
    var divClassName = classNames('CollapseBase__content', className);
    var moreStyle = !autoHeight ? {
      maxHeight: isExpanded ? this.getMaxHeight() + "px" : this.getCompactHeight() + "px"
    } : {};
    return React.createElement("div", _extends({
      id: id,
      style: moreStyle,
      className: classNames('CollapseBase', {
        'CollapseBase--expanded': isExpanded && autoHeight
      }),
      hidden: displayNone && !expanded,
      onTransitionEnd: this.handleTransitionEnd
    }, rest, {
      ref:
      /* istanbul ignore next */
      function ref(c) {
        _this3.container = c;
      }
    }), React.createElement("div", {
      className: divClassName
    }, children));
  };

  return CollapseBase;
}(Component);

CollapseBase.propTypes = {
  /** Flag to determine if the component is expanded or not on mount */
  expanded: PropTypes.bool,

  /** The CSS line-height of the content, used to calculate how many rows to display. Defaults to 22. You will likely not need to adjust this. */
  lineHeight: PropTypes.number,

  /** Total number of line rows (ems) to display when compact. Defaults to 0. */
  lines: PropTypes.number,

  /** Optional event handler to trigger when the component expands or collapses.  Passes the isExpanded boolean as a parameter */
  onExpandedChange: PropTypes.func,

  /** The CSS padding-bottom of the MoreOrLess container; used to calculate expanded and collapsed height. Defaults to 0.*/
  paddingBottom: PropTypes.number
};
CollapseBase.defaultProps = {
  expanded: false,
  lineHeight: 22,
  lines: 0,
  onExpandedChange: function onExpandedChange() {},
  paddingBottom: 0
};
export default CollapseBase;
//# sourceMappingURL=CollapseBase.js.map